import { type FC, type ReactNode } from 'react';

import { Carousel, type Media } from '../Carousel';

import styles from './CardGallery.css';

type CardGalleryProps = {
  media: Media[];
  getIsDeoptimised?(media: Media, index: number): boolean;
  /**
   * @default true
   */
  withControls?: boolean;
  /**
   * @default true
   */
  withCount?: boolean;
  labels: ReactNode;
  slotBottom: ReactNode;
  onChangeSlide(): void;
};

export const CardGallery: FC<CardGalleryProps> = props => {
  const { media, getIsDeoptimised, withControls, withCount, onChangeSlide, labels, slotBottom } = props;

  return (
    <div className={styles['container']} data-testid="card-gallery.container">
      <Carousel
        getIsDeoptimised={getIsDeoptimised}
        media={media}
        withControls={withControls}
        withCount={withCount}
        onSlideChange={onChangeSlide}
      />
      <div className={styles['feature-labels-wrapper']}>{slotBottom}</div>
      {labels}
    </div>
  );
};
